import React from "react";
import AgentLogIn from "../../organisms/AgentInitialPagesComponents/AgentLogIn/AgentLogIn";

const AgentLogInPage = () => {
  return <AgentLogIn />;
};

export default AgentLogInPage;
